const EXCLUDED_PM_ENTITYID_FOR_CHATBOT = {
  RETAIL: 1018900,
  HUL: 11173743,
  HULOPD: 11196092,
  BRITISHTELECOM: 11187564,
  DEUTSCHEBANK: 1005981,
};

const KEY_CHAIN = {
  ANDROID_MWEB: "AndroidmWeb",
  IOS_MWEB: "iOSmWeb",
  REDIRECT: "redirect",
  ACCESS_TOKEN: "accessToken",
  SURGERY_TYPEFORM_LINK: "https://form.typeform.com/to/sYzvVH6P?",
  SURGERY_TOKEN: "surgeryToken",
  WEB_SURGERY_BANNER_LINK:
    "https://views.medibuddy.in/surgeryBanners/Web_SurgeryNewBanner.png",
  MOBILE_SURGERY_BANNER_LINK:
    "https://views.medibuddy.in/surgeryBanners/mweb_SurgeryBanner.png",
  FRESHCHAT_CLIENT_ID: "af3c35e2-ff16-4db8-9825-394aacdbe72c",
  SNOW_PLOW_APP_ID: "faq-support-frontend",
  MINIMUM_VISIT_LENGTH: 10,
  HEARTBEAT_DELAY: 60,
};

const CONTACT_NUMBER = "08047188266";

module.exports = {
  EXCLUDED_PM_ENTITYID_FOR_CHATBOT,
  KEY_CHAIN,
  CONTACT_NUMBER,
};
